/*
    ContextState.js -- Global state
 */

export default class ContextState {
    inputs = {}

    saveState(state) {
        return state
    }

    loadState(state) {
        return state
    }

    setKey(key, value) {
        if (typeof key == 'object') {
            for (let [k, v] of Object.entries(key)) {
                if (k != 'id') {
                    this[k] = v
                }
            }
        } else if (key != 'id') {
            this[key] = value
        }
    }
}
